import { render, staticRenderFns } from "./StatisticCardVerticalPositive.vue?vue&type=template&id=449ea299&"
import script from "./StatisticCardVerticalPositive.vue?vue&type=script&lang=js&"
export * from "./StatisticCardVerticalPositive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports